import { Button, Checkbox } from "@clarkinc/zest-design-system/ui";
import { Throwable } from "@wss/error-tracking/throwable";
import React from "react";

interface FooterProps {
  addressPlusSignup: boolean;
  setMarketingOptIn: React.Dispatch<React.SetStateAction<boolean>>;
  marketingOptIn: boolean;
  submitting: boolean;
  submitForm: () => Promise<Throwable<void>>;
}

const Footer = ({
  addressPlusSignup,
  marketingOptIn,
  setMarketingOptIn,
  submitting,
  submitForm,
}: FooterProps) => {
  return (
    <div className="px-0 pt-6">
      {!addressPlusSignup && (
        <div className="pb-3 lm:pb-4">
          <Checkbox
            id="plus-promotions-checkbox"
            theme="wss"
            label="Send me Plus promotions and special offers."
            checked={marketingOptIn}
            onClick={() => setMarketingOptIn(!marketingOptIn)}
            labelProps={{ className: "mb-0" }}
          />
        </div>
      )}
      <p className="text-xs pt-0 mb-0 pb-5 lm:pb-2">
        By placing your order, you agree to WebstaurantStore&apos;s{" "}
        <a href="/policies.html" target="_blank" className="hover:underline">
          terms of sale
        </a>
        &nbsp;and{" "}
        <a
          href="/policies.html#Privacy_Policy"
          target="_blank"
          className="hover:underline"
        >
          privacy policy.
        </a>
      </p>
      {!submitting ? (
        <Button
          type="button"
          name="submit"
          onClick={submitForm}
          size="large"
          theme="wss"
          color="green"
          full
          data-testid="plus_confirm_subscription_button"
          id="plus_confirm_subscription_button"
        >
          <span
            data-default-text="Confirm Subscription"
            data-working-text="Preparing Your Savings"
          >
            Confirm Subscription
          </span>
        </Button>
      ) : (
        <button
          disabled
          type="button"
          name="submit"
          className="w-full mt-0 h-10 p-0 text-base font-semibold text-white bg-green-500 border rounded border-transparent hover:bg-green-700"
        >
          <span>
            <span className="icon-spinner" /> Preparing Your Savings
          </span>
        </button>
      )}
      <p className="lm:hidden text-xs text-black font-normal m-0 pt-4 md:pt-5">
        Special offers only valid for first time subscribers. This program only
        allows for a single shipping address and may be updated once per payment
        cycle if benefit is unused. Enrollment is open only to addresses located
        in the 48 contiguous United States. WebstaurantStore reserves the right
        to modify the terms of this program and to cancel this program at any
        time.
      </p>
    </div>
  );
};

export default Footer;
